import { Typography } from 'antd';
import styled, { css } from 'styled-components';
import { baseTextStyles } from './common.styled';

const { Text } = Typography;

const variantStyles = {
  body: css`
    font-family: 'DM Sans';
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
  `,
  caption: css`
    font-family: 'DM Sans';
    font-size: 12px;
    font-weight: 400;
    line-height: 14px;
  `,
};

export const StyledText = styled(Text)`
  ${baseTextStyles}

  ${({ $variant }) => $variant && variantStyles[$variant]}

  ${({ $color }) =>
    $color &&
    css`
      color: ${$color};
    `}

  &.capitalize {
    text-transform: capitalize;
  }
`;
